import Head from 'next/head'
import Image from 'next/image'
import { useRouter } from 'next/router'
import PageTitle from '../../components/PageTitle'

const CareersPage = () => {
  const router = useRouter()

  const renderHiring = () => {
    return (
      <div className="career">
        <div className="career__section">
          <div className="career__section__hero-image">
            <Image src="/images/careers/career-hero.png" alt="Hero Image" width={1440} height={320}/>
          </div>
          <div className="career__section__hero-image-mobile">
            <Image src="/images/careers/career-hero.png" alt="Hero Image" width={512} height={165}/>
          </div>
        </div>
        <div className="career__container">
          <div className="career__container__content">
            <h1>
              an extraordinary new store looking for extraordinary talent.
            </h1>
            <div className="career__container__content-text">
              <p>
                At pOpshelf, we believe shopping should be an experience you
                enjoy. A time to wander. Explore. Linger. A momentary escape to
                just be.
              </p>
              <p>
                We make it fun to find what you need and easy to buy what you
                want. It&apos;s the simple smile of discovery. In home décor,
                beauty &amp; body, household &amp; specialty finds, food &amp;
                spices, crafts and toys.
              </p>
              <p>
                This is pOpshelf. Where there&apos;s fun in every find. Surprise
                on every shelf. And joy in every visit.
              </p>
            </div>
          </div>
          <div className="career__container__button-row">
            <button className="btn__primary career__container__button-row-btn-element"
              onClick={() =>
                window.open(
                  'https://jobs-popshelf.icims.com/',
                  '_blank',
                  'noopener=yes'
                )
              }
            >
              search store positions
            </button>
            <button className="btn__primary career__container__button-row-btn-element"
              onClick={() =>
                window.open(
                  'https://ssc-dollargeneral.icims.com/jobs/search?ss=1&searchKeyword=popshelf',
                  '_blank',
                  'noopener=yes'
                )
              }
            >
              search corporate positions
            </button>
          </div>
          <div className="career__container__map-container">
            <iframe
              src="https://app.careerarc.com/job_maps/431"
              allow="geolocation"
            ></iframe>
          </div>
          <div className="career__container__button-row">
            <button
              className='btn__secondary career__container__button-row-btn-element'
              onClick={() => {
                router.push('/careers/diversity')
              }}
            >
              diversity &amp; inclusion
            </button>
            <button
              className='btn__secondary career__container__button-row-btn-element'
              onClick={() => {
                router.push('/careers/benefits')
              }}
            >
              benefits
            </button>
          </div>
          <div className="career__container__bottom-image">
            <Image src="/images/careers/popshelf_employees_posing 1.png" alt="Popshelf Employees Image" width={1024} height={460}/>
          </div>
        </div>
      </div>
    )
  }

  const renderCareersContent = () => {
    return (
      <>
        <Head>
          <title>We Are Hiring</title>
          <meta name="description" content="Careers" />
        </Head>
        {renderHiring()}
      </>
    )
  }

  return (
    <div id="main-content" className='outer-section'>
      {<PageTitle title={'careers'} />}
      {renderCareersContent()}
    </div>
  )
}

export const getServerSideProps = async () => {
  return {
    props: {}
  }
}

export default CareersPage
